<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";

	const { items }: { items: string[] } = $props();
</script>

<section class="p-4 md:p-6 lg:p-8 xl:p-10 border-fcrdarkgray border-y text-fcrbrown full-width grid-container">
	<ul
		class="flex justify-around items-center gap-8 flex-col sm:flex-row sm:flex-wrap text-sm/tighter font-semibold uppercase list-disc tracking-[.1em]"
	>
		{#each items as item (item)}
			<li><Formatted text={item} /></li>
		{/each}
	</ul>
</section>
